import axios from "axios";
import {  ADMIN_BASE_URL} from "./endpoints";
import { getToken } from "../utils/authHelper";
import { LayoutGroup } from "framer-motion";
import { AdminPanelSettings, Folder, FormatQuoteRounded, Help } from "@mui/icons-material";
import { Nav, Navbar } from "react-bootstrap";
import { useValueWithTimezone } from "@mui/x-date-pickers/internals/hooks/useValueWithTimezone";
import { OfferRejectedApi } from "../features/Admin/Reports/AdminReports";
import { RiSideBarFill } from "react-icons/ri";
import { ca } from "date-fns/locale";
import SearchBar from "../pages/Admin/Logs/SearchBar";
const adminAxiosInstance = axios.create({
  baseURL: ADMIN_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const adminAxiosFormInstance = axios.create({
  baseURL: ADMIN_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
adminAxiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
adminAxiosFormInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default adminAxiosInstance;

